import { rem } from 'polished';
import styled from 'styled-components';
import { CheckoutAssistedFinanceStyled } from '../CheckoutAssistedFinanceStyled';

export const CheckoutAssistedFinanceStyledOV = styled(CheckoutAssistedFinanceStyled)`
    .description { 
        .descriptionBox2 {
             background: ${({ theme }) => theme.colors.grey20};
        }
    }

    .select {
        .selectLeft,
        .selectRight {
            border: 2px solid ${({ theme }) => theme.colors.grey18};
            
            &.selected {
                background: ${({ theme }) => theme.colors.grey10};
                border-color: ${({ theme }) => theme.colors.black2};
            }
        }

        .selectIcon {
            border: 1px solid ${({ theme }) => theme.colors.grey1};
            
            &.selected {
                border-color: ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.primary};
            }
          
            .selected {
                background: ${({ theme }) => theme.colors.black2};
                width: ${rem(11)};
                height: ${rem(11)};
                left: ${rem(6)};
                top: ${rem(6)};
            }
        }

        .selectTitle {
            color: ${({ theme }) => theme.colors.black2};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        .selectDescription {
            color: ${({ theme }) => theme.colors.grey28};
        }
    }
`;
